import { HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr';
import { setConState, setPeers, addGroup, removeGroup, receivedMessage, receivedTaskUpdate, receivedMapUpdate } from "./signalrSlice"
import * as App from '../index'
import { msalConfig } from "../authConfig"

const signalrMiddleware = ({ dispatch, getState }) => {
    let hubConnection
    return (next) => async (action) => {
        if (action.type === 'connect') {
            if (!hubConnection) {
                const account = App.msalInstance.getAllAccounts()[0]
                const tokenRequest = {
                    account: account,
                    scopes: msalConfig.auth.scopes,
                }
                // console.log(`signalr tokenRequest: ${JSON.stringify(tokenRequest)}`)
                //const authenticationResult = await App.msalInstance.acquireTokenSilent(tokenRequest)
                //console.log(`signalr authenticationResult: ${JSON.stringify(authenticationResult)}`)
                hubConnection = new HubConnectionBuilder()
                    .withUrl(`${window.location.origin}/hubs/remote`, {
                        accessTokenFactory: async () => {
                            const authenticationResult = await App.msalInstance.acquireTokenSilent(tokenRequest)
                            // console.log(`signalr authenticationResult: ${JSON.stringify(authenticationResult)}`)
                            return authenticationResult.accessToken
                        }
                    })
                    //.configureLogging(LogLevel.Information)
                    .withAutomaticReconnect()
                    .build()
                hubConnection.onclose((err) => {
                    dispatch(setConState({ state: hubConnection.state, error: err }))
                })
                hubConnection.onreconnecting((err) => {
                    dispatch(setConState({ state: hubConnection.state, error: err }))
                })
                hubConnection.onreconnected((conId) => {
                    dispatch(setConState({ state: hubConnection.state, error: null }))
                })
            }
            if (hubConnection.state === 'Disconnected') {
                hubConnection.start()
                    .then(() => {
                        dispatch(setConState({ state: hubConnection.state, error: null }))
                        hubConnection.on('ReceiveMessage', received => {
                            dispatch(receivedMessage(received))
                        });
                        hubConnection.on('ReceiveTaskUpdate', received => {
                            dispatch(receivedTaskUpdate(received))
                        })
                        hubConnection.on('ReceiveMapUpdate', received => {
                            dispatch(receivedMapUpdate(received))
                        })
                    }).catch(err => {
                        dispatch(setConState({ state: hubConnection.state, error: err }))
                    })
            }
        } else if (action.type === 'disconnect') {
            await hubConnection.stop()
        } else if (action.type === 'sendServer') {
            if (hubConnection?.state == HubConnectionState.Connected) {
                hubConnection.invoke(action.function)
                    .then((data) => {
                        dispatch(setPeers(data))
                    })
            }
        } else if (action.type === 'sendUser') {
            if (hubConnection?.state == HubConnectionState.Connected) {
                hubConnection.invoke('SendUserMessage', action.userId, action.message)
            }
        } else if (action.type === 'joinGroup') {
            if (hubConnection?.state == HubConnectionState.Connected) {
                hubConnection.invoke('AddToGroup', action.group)
                dispatch(addGroup(action.group))
            }
        } else if (action.type === 'leaveGroup') {
            if (hubConnection?.state == HubConnectionState.Connected) {
                hubConnection.invoke('RemoveFromGroup', action.group)
            }
            dispatch(removeGroup(action.group))
        }
        return next(action)
    }
}
export default signalrMiddleware